/* CERA — behaviour for the product page sections below the fold.
   Ported from the prototype: carousel arrows, the before/after slider with its
   intro sweep, the colour cross-fade, and the lightbox
   shared by the photo and video galleries.

   The lightbox markup is built here rather than in a section, because two
   sections open it and duplicating the dialog would duplicate its ids. */
(function () {
  'use strict';

  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function json(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  function addVariant(id) {
    if (window.CeraCart && window.CeraCart.add) return window.CeraCart.add(id, 1);
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    });
  }

  /* ---------- Carousel arrows ---------- */

  $$('[data-cera-sx-track]').forEach(function (track) {
    var head = track.parentNode;
    var prev = $('[data-cera-sx-prev]', head);
    var next = $('[data-cera-sx-next]', head);
    if (!prev || !next) return;

    function step() { return track.clientWidth * 0.7; }
    function update() {
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft > track.scrollWidth - track.clientWidth - 4;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Lightbox ---------- */

  var lb = null, lbList = [], lbI = 0, lbKind = 'photo', lbLabels = {};

  function buildLightbox() {
    if (lb) return lb;
    var wrap = document.createElement('div');
    wrap.className = 'cera';
    wrap.innerHTML =
      '<div class="lb" hidden>' +
        '<div class="lb-scrim" data-close></div>' +
        '<div class="lb-box" role="dialog" aria-modal="true" aria-label="Detail view">' +
          '<button type="button" class="lb-x" data-close aria-label="Close">' +
            '<svg viewBox="0 0 14 14"><path d="M1 1l12 12M13 1L1 13"/></svg>' +
          '</button>' +
          '<div class="lb-media" data-lb-media></div>' +
          '<div class="lb-side" data-lb-side></div>' +
          '<button type="button" class="lb-nav p" data-lb-prev aria-label="Previous">&larr;</button>' +
          '<button type="button" class="lb-nav n" data-lb-next aria-label="Next">&rarr;</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(wrap);
    lb = $('.lb', wrap);

    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) return lbClose();
      if (e.target.closest('[data-lb-prev]')) { lbI = (lbI - 1 + lbList.length) % lbList.length; return lbRender(); }
      if (e.target.closest('[data-lb-next]')) { lbI = (lbI + 1) % lbList.length; return lbRender(); }
      var add = e.target.closest('[data-lb-add]');
      if (add) { var id = add.dataset.lbAdd; lbClose(); addVariant(id); }
    });

    document.addEventListener('keydown', function (e) {
      if (!lb || lb.hidden) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowRight') { lbI = (lbI + 1) % lbList.length; lbRender(); }
      if (e.key === 'ArrowLeft') { lbI = (lbI - 1 + lbList.length) % lbList.length; lbRender(); }
    });

    return lb;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function lbOpen(list, i, labels) {
    buildLightbox();
    lbList = list; lbI = i; lbLabels = labels || {};
    lbKind = (list[i] && list[i].kind) || 'photo';
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
    lbRender();
    $('.lb-x', lb).focus();
  }

  function lbClose() {
    if (!lb) return;
    lb.hidden = true;
    var drawer = $('[data-cera-cart]');
    if (!drawer || !drawer.classList.contains('on')) document.body.style.overflow = '';
  }

  function lbRender() {
    var it = lbList[lbI];
    if (!it) return;
    var box = $('.lb-box', lb);
    box.classList.toggle('vid', it.kind === 'video');

    var media = '';
    if (it.kind === 'video' && it.video) {
      if (/\.(mp4|webm|mov)(\?|$)/i.test(it.video)) {
        media = '<video src="' + esc(it.video) + '" controls autoplay playsinline ' +
                'style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover"' +
                (it.image ? ' poster="' + esc(it.image) + '"' : '') + '></video>';
      } else {
        media = '<iframe src="' + esc(it.video) + '" allow="autoplay; fullscreen" allowfullscreen ' +
                'title="' + esc(it.title) + '" frameborder="0" ' +
                'style="position:absolute;inset:0;width:100%;height:100%"></iframe>';
      }
    } else if (it.image) {
      media = '<span class="ph' + (it.dark ? ' dark' : '') + '"><img src="' + esc(it.image) + '" alt="' + esc(it.title) + '"></span>';
    }
    $('[data-lb-media]', lb).innerHTML = media;

    var items = (it.items || []).map(function (p) {
      var thumb = p.image
        ? '<span class="ph"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '"></span>'
        : '<span class="ph"></span>';
      var button = p.available
        ? '<button type="button" data-lb-add="' + p.id + '">' + esc(lbLabels.add || 'Add') + '</button>'
        : '<button type="button" disabled>' + esc(lbLabels.soldOut || 'Sold out') + '</button>';
      return '<div class="lb-it">' + thumb +
             '<div><b>' + esc(p.title) + '</b><span>' + esc(p.price) + '</span></div>' +
             button + '</div>';
    }).join('');

    $('[data-lb-side]', lb).innerHTML =
      (it.handle || it.meta ? '<div class="hdl">' + esc(it.handle) + (it.handle && it.meta ? ' · ' : '') + esc(it.meta) + '</div>' : '') +
      '<h3>' + esc(it.title) + '</h3>' +
      (it.caption ? '<p>' + esc(it.caption) + '</p>' : '') +
      (items ? '<h5>' + esc(lbLabels.shown || 'Shown here') + '</h5>' + items : '') +
      (it.own ? '<p class="small">' + esc(it.own) + '</p>' : '') +
      '<span class="small" style="margin-top:auto;color:var(--stone)">' + (lbI + 1) + ' / ' + lbList.length + '</span>';
  }

  $$('[data-cera-lb-group]').forEach(function (track) {
    var group = track.dataset.ceraLbGroup;
    var data = json($('[data-cera-lb-data="' + group + '"]'));
    if (!data) return;
    var labels = {
      shown: track.dataset.lbShown,
      add: track.dataset.lbAdd,
      soldOut: track.dataset.lbSold
    };
    track.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-cera-lb-item]');
      if (!tile) return;
      lbOpen(data, parseInt(tile.dataset.ceraLbItem, 10), labels);
    });
  });

  /* The before/after slider moved to cera-ba.js, which the PDP gallery loads
     too. */

  /* The vessel calculator moved to cera-calc.js, which the buy box loads
     too. */

  /* ---------- Colours ---------- */

  $$('[data-cera-cols]').forEach(function (sec) {
    var data = json($('[data-cera-cols-data]', sec.parentNode) || $('[data-cera-cols-data]'));
    var labels = json($('[data-cera-cols-labels]', sec.parentNode) || $('[data-cera-cols-labels]')) || {};
    if (!data || !data.length) return;

    var imgs = $$('[data-cera-cols-imgs] .ph', sec);
    var tabs = $$('[data-cera-cols-tabs] button', sec);
    var nameEl = $('[data-cera-col-name]', sec);
    var descEl = $('[data-cera-col-desc]', sec);
    var pairEl = $('[data-cera-col-pair]', sec);
    var addEl = $('[data-cera-col-add]', sec);
    var i = 0;

    function apply() {
      var c = data[i];
      if (nameEl) nameEl.textContent = c.name;
      if (descEl) descEl.textContent = c.desc;
      if (pairEl) pairEl.innerHTML = c.pair ? '<b>' + esc(labels.pairs || '') + '</b>' + esc(c.pair) : '';
      if (addEl) {
        addEl.textContent = c.available
          ? String(labels.add || '').replace('{name}', c.name).replace('{price}', c.price)
          : (labels.soldOut || 'Sold out');
        addEl.disabled = !c.available;
        addEl.dataset.variant = c.id || '';
      }
      sec.classList.remove('swap');
    }

    function set(n, first) {
      i = n;
      imgs.forEach(function (el, k) { el.classList.toggle('on', k === n); });
      tabs.forEach(function (b, k) { b.setAttribute('aria-selected', String(k === n)); });
      if (first) return apply();
      sec.classList.add('swap');
      setTimeout(apply, 300);
    }

    tabs.forEach(function (b) {
      b.addEventListener('click', function () { set(parseInt(b.dataset.ceraCol, 10), false); });
    });
    if (addEl) {
      addEl.addEventListener('click', function () {
        if (addEl.dataset.variant) addVariant(addEl.dataset.variant);
      });
    }
    set(0, true);
  });

  /* The final CTA's tiers are the shared buy block now, wired in cera-pdp.js
     along with the product page's. Nothing to do here. */
})();